(() => {
  "use strict";

  const speed = 0.5;

  document.addEventListener("DOMContentLoaded", () => {
    document.querySelectorAll(".js-breakdown-parent").forEach((parent) => {
      const btn = parent.querySelector(".js-breakdown-button");
      const content = parent.querySelector(".js-breakdown-content");
      if (!btn || !content) return;

      // 初期状態で閉じる
      gsap.set(content, { height: 0, overflow: "hidden", display: "none" });

      const openContent = () => {
        gsap.killTweensOf(content);
        parent.classList.add("-active");

        // 表示してから高さを計測
        content.style.display = "block";
        const fullHeight = content.scrollHeight;

        // 高さ + スライドy
        gsap.fromTo(
          content,
          { height: 0, overflow: "hidden" },
          {
            height: fullHeight,
            duration: speed,
            ease: "power2.out",
            onComplete: () => {
              // 自然なレイアウトに戻す
              content.style.height = "auto";
              content.style.overflow = "";
              // transform はクリア（副作用防止）
              gsap.set(content, { clearProps: "transform" });
            },
          }
        );
      };

      const closeContent = () => {
        gsap.killTweensOf(content);

        const currentHeight = content.scrollHeight;

        // 高さを0へ＋少し上にスライド
        gsap.to(content, {
          height: 0,
          duration: speed,
          ease: "power2.in",
          overwrite: true,
          onComplete: () => {
            parent.classList.remove("-active");
            content.style.display = "none";
            content.style.height = "";
            content.style.overflow = "";
            // transform をクリア
            gsap.set(content, { clearProps: "transform" });
          },
        });
      };

      btn.addEventListener("click", (e) => {
        e.preventDefault();
        if (parent.classList.contains("-active")) {
          closeContent();
        } else {
          openContent();
        }
      });
    });
  });
})();
